"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTransition = void 0;
exports.hexToRgbA = hexToRgbA;
var _styledComponents = require("styled-components");
const getTransition = (duration, property = ['background-color', 'color'], animation = 'ease') => (0, _styledComponents.css)`
		transition-property: ${Array.isArray(property) ? property.join(', ') : property};
		transition-duration: ${duration}ms;
		transition-timing-function: ${animation};
	`;
exports.getTransition = getTransition;
function hexToRgbA(hex, opacity = '1') {
  var c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('');
    if (c.length == 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = '0x' + c.join('');
    return 'rgba(' + [c >> 16 & 255, c >> 8 & 255, c & 255].join(',') + ',' + opacity + ')';
  }
  return 'none';
}